export default function () {
  this.date = new Date().getFullYear();

  // check if local data is cached and if so apply it.
  const cache = JSON.parse(localStorage.getItem("cache"));
  cache ? ((this.options = cache.options), (this.state = cache.state)) : null;

  this.requestPassword();
}
